import { apiFetch } from '../../lib/apiFetch';

import { throwTreeReplacementError } from './errors';
import type {
  CreateTreeReplacementInput,
  TreeReplacementDetail,
  TreeSpeciesOption,
  UpdateTreeReplacementInput,
  WorkshopTreeReplacement,
} from './types';

export async function createTreeReplacement(
  workshopId: string,
  input: CreateTreeReplacementInput,
): Promise<WorkshopTreeReplacement> {
  const res = await apiFetch(`/api/v1/workshops/${workshopId}/tree-replacements`, {
    method: 'POST',
    body: JSON.stringify(input),
  });
  if (!res.ok) await throwTreeReplacementError(res, 'workshop');
  const body = (await res.json()) as { treeReplacement: WorkshopTreeReplacement };
  return body.treeReplacement;
}

export async function fetchTreeReplacement(
  workshopId: string,
  treeReplacementId: string,
): Promise<TreeReplacementDetail> {
  const res = await apiFetch(
    `/api/v1/workshops/${workshopId}/tree-replacements/${treeReplacementId}`,
  );
  if (!res.ok) await throwTreeReplacementError(res, 'replacement', 'view');
  const body = (await res.json()) as { treeReplacement: TreeReplacementDetail };
  return body.treeReplacement;
}

export async function updateTreeReplacement(
  workshopId: string,
  treeReplacementId: string,
  patch: UpdateTreeReplacementInput,
): Promise<WorkshopTreeReplacement> {
  const res = await apiFetch(
    `/api/v1/workshops/${workshopId}/tree-replacements/${treeReplacementId}`,
    { method: 'PATCH', body: JSON.stringify(patch) },
  );
  if (!res.ok) await throwTreeReplacementError(res, 'replacement');
  const body = (await res.json()) as { treeReplacement: WorkshopTreeReplacement };
  return body.treeReplacement;
}

/** Active species, sorted by name, for the species picker. */
export async function fetchTreeSpeciesOptions(): Promise<TreeSpeciesOption[]> {
  const res = await apiFetch('/api/v1/tree-species');
  if (!res.ok) throw new Error('Couldn’t load the species list.');
  const body = (await res.json()) as { species: TreeSpeciesOption[] };
  return body.species;
}
